var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(-1339 -779.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(1115.707 475.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.117,19.507a3.072,3.072,0,0,1-2.28-.83c-.88-.88-1.5-2.75.48-6.72l.87-1.73a1.38,1.38,0,0,0,0-.94l-.87-1.73c-1.99-3.97-1.36-5.85-.48-6.72s2.75-1.51,6.71.48l8.56,4.28c2.13,1.06,3.3,2.54,3.3,4.16s-1.17,3.1-3.29,4.16L7.557,18.2A10.276,10.276,0,0,1,3.117,19.507Zm0-18A1.687,1.687,0,0,0,1.9,1.9c-.73.72-.44,2.59.76,4.98l.87,1.74a2.828,2.828,0,0,1,0,2.28l-.87,1.73c-1.2,2.4-1.49,4.26-.76,4.98s2.59.44,4.99-.76l8.56-4.28c1.57-.78,2.46-1.81,2.46-2.82s-.9-2.04-2.47-2.82l-8.56-4.27A9.2,9.2,0,0,0,3.117,1.507Z",
    transform: "translate(238.293 318.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.15,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h5.4A.755.755,0,0,1,6.9.75.755.755,0,0,1,6.15,1.5Z",
    transform: "translate(240.69 327.25)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/Icon-send.3e18a251a71cc3c1fc1c26bf58b6f3a4.svg";
export { ForwardRef as ReactComponent };